document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  const authenticatedCustomerEl = document.getElementById('authenticatedCustomer');
  const authenticatedCustomerId = authenticatedCustomerEl?.dataset?.customerId;
  const mediaTitleEl = document.getElementById('mediaTitle');

  const container = document.querySelector('.player-page__video-container');
  const iframe = document.getElementById('videoPlayerIframe');

  if (!container || !iframe) return;

  const now = Math.floor(Date.now() / 1000);

  function renderError(message) {
    container.innerHTML = `<h4 class="h4">${message}</h4>`;
  }

  function getStoredPayload() {
    try {
      const selectedSubLink = sessionStorage.getItem('selected_sub_link');
      if (selectedSubLink) {
        const parsed = JSON.parse(selectedSubLink);

        // non-DRM sublink
        if (parsed && parsed.url) {
          return {
            type: 'sublink',
            title: parsed.title || '',
            url: parsed.url,
            expires: parseInt(sessionStorage.getItem('expires') || '', 10),
            customer: sessionStorage.getItem('customer') || ''
          };
        }
      }
    } catch (e) {
      console.warn('Failed to parse selected_sub_link:', e);
    }

    try {
      const selectedLink = sessionStorage.getItem('selected_link');
      if (selectedLink) {
        const parsed = JSON.parse(selectedLink);
        if (parsed && parsed.url) {
          return {
            type: 'parent',
            title: parsed.title || '',
            url: parsed.url,
            expires: parseInt(parsed.expires || '', 10),
            customer: parsed.customer || ''
          };
        }
      }
    } catch (e) {
      console.warn('Failed to parse selected_link:', e);
    }

    return null;
  }

  function getLegacyUrlPayload() {
    const libId = params.get('lib_id');
    const mediaId = params.get('media_id');
    const token = params.get('token');
    const expires = parseInt(params.get('expires'), 10);
    const customerParam = params.get('customer');
    const title = params.get('title');

    if (
      libId &&
      mediaId &&
      token &&
      expires &&
      customerParam
    ) {
      return {
        type: 'legacy',
        title: title ? decodeURIComponent(title) : '',
        url: `https://iframe.mediadelivery.net/embed/${libId}/${mediaId}?token=${token}&expires=${expires}`,
        expires,
        customer: customerParam
      };
    }

    return null;
  }

  const payload = getStoredPayload() || getLegacyUrlPayload();

  if (!payload) {
    renderError('Access denied or invalid video data.');
    return;
  }

  if (!authenticatedCustomerId || payload.customer !== authenticatedCustomerId) {
    renderError('Access denied or invalid customer.');
    return;
  }

  if (!payload.expires || now > payload.expires) {
    renderError('This video link has expired.');
    return;
  }

  if (payload.title && mediaTitleEl) {
    mediaTitleEl.textContent = payload.title;
  }

  iframe.src = payload.url;
});